export const YOUR_BUSINESS_INDEX = 0;
export const YOUR_OFFER_INDEX = 1;
export const CREDIT_CHECK_INDEX = 2;
export const FINAL_DETAILS_INDEX = 3;

export const FIXED_HEADER_OFFSET = -175;
